import React from 'react'
import contentoh from "../../../assets/IconComponents/contentoh-logo.svg";

const Logo = () => {
  return (
    <img src={contentoh} alt="contentoh-logo" />
  )
}

export default Logo